import { AppProps } from "next/app";

import "../styles/react-autosuggest.css";
import "../styles/normalize.css";
import "../styles/rti-reset.css";
import "../styles/index.css";

export default function MyApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}
